<div fxFlex="100" id="plan-overview">
    <div id="search-and-sort-plans" fxLayout="row" fxLayoutAlign="left center">
        <mat-icon class="material-icons search">&#xE8B6;</mat-icon>
        <mat-form-field>
            <input matInput type="text" [(ngModel)]="searchText" placeholder="Search plans" />
        </mat-form-field>
        <mat-form-field class="sort-by-select">
            <mat-select placeholder="Sort By" [(ngModel)]="displayOrder">
                <mat-option *ngFor="let option of sortOptions" [value]="option">{{ option.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="column" class="plan-container">
        <h2 *ngIf="documentService.store.undeletedPlanMetadata && documentService.store.undeletedPlanMetadata.length > 0">Plans</h2>
        <cdk-virtual-scroll-viewport itemSize="100" style="height: 75vh;" id="plan-library">
            <plan-document-list-item *cdkVirtualFor="let plan of documentService.store.undeletedPlanMetadata | sort: displayOrder.docCode | searchfilterplan: searchText" fxLayout="row" fxLayout.lt-md="column" class="plan-row" [class.disabled]="!isOnline && !plan.isDownloaded"
                [plan]="plan" [isOnline]="isOnline" (clicked)="goTo($event)" (downloaded)="goTo($event)" (viewed)="goTo($event)" (published)="publishPlan($event)" (shared)="sharePlan($event)" (copied)="copyPlan($event)" (deleted)="deletePlan($event)" (edited)="editPlan($event)">
            </plan-document-list-item>
        </cdk-virtual-scroll-viewport>
    </div>

    <button mat-fab class="fixed-fab" id="create-plan-button" (click)="createPlan()">
    <mat-icon>add</mat-icon>
  </button>
</div>
<ngx-guided-tour></ngx-guided-tour>